import React from 'react';
import axios from 'axios';
import 'CSS/Member/ResetPassword.css';

export default function ResetPassword() {

	const [password, setPassword] = React.useState('');
	const [message, setMessage] = React.useState('');
	const [messageClass, setMessageClass] = React.useState('error-message');
	const [done, setDone] = React.useState(false);

	const token = new URLSearchParams(window.location.search).get('reset-token');

	function submit(event) {
		event.preventDefault();
		axios.post('Backend/webapp.php?module=Public&task=ResetPassword', {
			token: token,
			newPassword: password,
		}).then((result) => {
			setMessage(result.data.content.message);
			setMessageClass((result.data.returncode === 1) ? 'success-message' : 'error-message');
			setDone(result.data.returncode === 1);
		});
	}

	return (
		<div className="reset-password-frame">
			<div className="reset-password-box">
				<div className="reset-password-title">Neues Passwort setzen</div>
				<div className="reset-password-content">
					{done ? (
						<div className={`reset-password-message ${messageClass}`}>{message}</div>
					) : (
						<form onSubmit={submit}>
							<label>Neues Kennwort</label>
							<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
							{message !== '' ? <div className={`reset-password-message ${messageClass}`}>{message}</div> : null}
							<button type="submit">Passwort setzen</button>
						</form>
					)}
				</div>
			</div>
		</div>
	);
}
